import { DropdownOption } from "@app2/shared/predicate-dropdown-menu.component";
import { InfoNoteThreatLevel } from "@app2/type-defs/metadata/metadata-types";

export const threatLevelColors: Record<InfoNoteThreatLevel, ("threat-level-zero" | "threat-level-one" | "threat-level-two" | "threat-level-three")> = {
    ZERO: "threat-level-zero",
    ONE: "threat-level-one",
    TWO: "threat-level-two",
    THREE: "threat-level-three"
};

export const threatLevelOptions: DropdownOption<InfoNoteThreatLevel>[] = [
    { key: "THREAT_LEVEL_ZERO", value: InfoNoteThreatLevel.ZERO },
    { key: "THREAT_LEVEL_ONE", value: InfoNoteThreatLevel.ONE },
    { key: "THREAT_LEVEL_TWO", value: InfoNoteThreatLevel.TWO },
    { key: "THREAT_LEVEL_THREE", value: InfoNoteThreatLevel.THREE },
];